import { lineAccountLinks } from "constants/links";

export const HIGURASHI_CHARACTER_KEYS = ["keiichi", "rena", "mion"];

const HIGURASHI_CHARACTER_PROFILES = {
  keiichi: {
    name: "前原圭一",
    description: "都会から雛見沢に引っ越してきた熱血漢の少年。",
  },
  rena: {
    name: "竜宮レナ",
    description: "常に笑顔で優しい中想いの少女。可愛いものを集めている。",
  },
  mion: {
    name: "園崎魅音",
    description: "元気で面倒見がいい姉御肌。村の有力者「園崎家」の次期当主。",
  },
};

export const getHigurashiSouls = ({
  visualStyle = "original",
  lng = "ja",
} = {}) => {
  const style = visualStyle || "original";
  const language = lng || "ja";
  const languageLinks =
    lineAccountLinks.higurashi?.[language] || lineAccountLinks.higurashi?.ja;
  const lineLinks = languageLinks?.[style] || languageLinks?.original || {};

  return HIGURASHI_CHARACTER_KEYS.map((character) => ({
    character,
    ...HIGURASHI_CHARACTER_PROFILES[character],
    imageURL: `https://soulchat.sekaie.in/assets/higurashi/profile_images/${style}/${character}.webp`,
    lineUrl: lineLinks[character],
  }));
};

export const getOtherHigurashiSouls = ({ character, visualStyle, lng } = {}) =>
  getHigurashiSouls({ visualStyle, lng }).filter(
    (soul) => soul.character !== character
  );
